import React from 'react';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton } from '../../../../components';
import { Block } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import requestInProgressImage from '../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../assets/icons/pse/RequestInProgress.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import Spinner from '@/presentation/components/Spinner';

const PseProgressView = ({
  handlerBackButton,
  procedure,
  isLoadingStatus,
  status
}: any) => {
  let images;
  let title;
  let subtitle;
  const textIsAutomatic = procedure?.detail?.isAutomatic
    ? 'Validación automática'
    : 'Validación manual';
  const dateByStatus =
    status?.status?.status === 'PENDIENTE'
      ? `Fecha estimada de respuesta: ${procedure?.steps[1]?.date ?? ' - '}`
      : `Fecha de respuesta: ${procedure?.steps[1]?.date ?? ' - '}`;
  switch (status?.status?.status) {
    case 'PROCEDE':
      images = [documentSuccessImage, documentSuccessDskImage];
      title = 'Tu validación ha sido aprobada';
      subtitle = 'Tu validación ha sido aplicado correctamente.';
      break;
    case 'NO_PROCEDE':
      images = [documentFailedImage, documentFailedDskImage];
      title = 'Tu solicitud no procede';
      subtitle =
        'El documento adjunto no es válido para sustentar tu seguro de salud.';
      break;
    default:
      images = [requestInProgressImage, requestInProgressDskImage];
      title = 'Tu solicitud está en proceso';
      subtitle =
        'Te notificaremos por correo cuando tu solicitud está finalizada';
      break;
  }
  return (
    <ContainerProcedure>
      <SubContainer style={{ marginBottom: 24 }}>
        <BackButton onClick={handlerBackButton} />
      </SubContainer>
      {isLoadingStatus && <Spinner />}
      {!isLoadingStatus && procedure && (
        <SubContainer>
          <ToggleHeader
            name={'Validación de Seguro'}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            status={status.status}
            childContent={<ProcedureInfoComponent inRegister />}
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              isComplete
              isCurrent={procedure.steps[0].isCurrent}
            >
              <div style={{ fontSize: '12px', lineHeight: '20px' }}>
                <p>Resumen:</p>
                <li>{procedure?.detail?.period}.</li>
                <li>{textIsAutomatic}.</li>
              </div>
            </Step>
            <Step
              name={procedure.steps[1].name}
              order={procedure.steps[1].order}
              isComplete={['PROCEDE', 'NO_PROCEDE'].includes(
                status.status.status
              )}
              isLast
            >
              <div style={{ fontSize: '12px', lineHeight: '20px' }}>
                <p>{`Fecha de solicitud: ${procedure.steps[0].date}`}</p>
                <p>{dateByStatus}</p>
              </div>
              <CardProgress image={images} title={title} subtitle={subtitle} />
            </Step>
          </Block>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default PseProgressView;
